import { Badge } from "../components/ui";
import type { DogWorkflowStatus } from "./api";

const LABELS: Record<DogWorkflowStatus, string> = {
  draft: "Bản nháp",
  pending_review: "Chờ duyệt",
  published: "Đã công khai",
  needs_changes: "Cần chỉnh sửa",
  disputed: "Đang tranh chấp",
  archived: "Đã lưu trữ",
  rejected: "Bị từ chối",
};

const TONES: Record<DogWorkflowStatus, "neutral" | "success" | "warning" | "danger" | "info"> = {
  draft: "neutral",
  pending_review: "info",
  published: "success",
  needs_changes: "warning",
  disputed: "danger",
  archived: "neutral",
  rejected: "danger",
};

export function DogStatusBadge({ status }: { status: DogWorkflowStatus }) {
  return <Badge tone={TONES[status]}>{LABELS[status]}</Badge>;
}

export function dogStatusLabel(status: DogWorkflowStatus): string {
  return LABELS[status];
}
